import { BaseDto } from './base.dto';
import { BookingStatusHistoryDto } from './bookingStatusHistory.dto';
import { CustomerDto } from './customer.dto';
import { BookingMerchantSaleUnitDto } from './bookingMerchantSaleUnit.dto';

export class BookingDto extends BaseDto {
    id: number;
    startDateTime: Date;
    endDateTime: Date;
    bookingDateAsInt?: number;
    startTimeAsInt?: number;
    endTimeAsInt?: number;
    merchantSaleUnitIds: string;
    merchantSaleRoomId: number;
    notes?: string;
    noPersons: number;
    status: BookingStatusHistoryDto;
    lastStatusId?: number;
    customer?: CustomerDto;
    bookingMerchantSaleUnits: BookingMerchantSaleUnitDto[];
    bookingName: string;
    phoneNumber: string;
    emailAddress: string;
  }
  